import React, { useState, useEffect, useMemo } from "react";

import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import reddelete from "../../images/red-Delete.svg";
import exclamation from "../../images/exclamation-mark.jpg";
import { useDispatch, useSelector } from "react-redux";

import {
  getSurves,
  createSurvey,
  updateSurvey,
  getPatientByProviderId,
  getAllPatientForAdmin,
  assignSurvey,
  assignSurveyToAllPatient,
} from "../services/providerService";
import { useFormik } from "formik";
import { formikCreateSurvey } from "./validation";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import eyeimg from "../../images/eye.svg";
import plusIcon from "../../images/plusIcon.svg";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import "./surveyList.css";
import Loader from "../../utils/Loader";
import { filterData } from "../../utils/filter";

function SurveyList() {
  const userdata = useSelector((state) => state);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [editData, setEditData] = useState(null);

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  // pagination for patient list to assign survey
  const [limitAssign, setLimitAssign] = useState(10);
  const [pageAssign, setPageAssign] = useState(1);
  const [totalPagesAssign, setTotalPagesAssign] = useState(0);
  const [totalItemsAssign, setTotalItemsAssign] = useState(0);

  const [surveyList, setSurveyList] = useState([]);

  const token = useSelector((state) => state?.login?.data?.accessToken);
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [selectedMediaTypeValue, setSelectedMediaTypeValue] = useState("");
  const { data } = useSelector((state) => state.login);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    _getSurveyList();
  }, [page, limit]);

  const _getSurveyList = async (searchText, sortby) => {
    setLoading(true);
    const respose = await getSurves({
      page: page + 1,
      limit,
      searchKey: searchText,
      sortBy: sortby,
    });
    if (respose?.status === "SUCCESS") {
      setSurveyList(respose?.data?.list);
      setTotalPages(respose?.data?.totalPages || 0);
      setTotalItems(respose?.data?.totalItems || 0);
    }
    setLoading(false);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      setLoading(true);
      _getSurveyList(query, selectedSortValue);
    }
    setLoading(false);
  };

  const handleSearchAssignPatientChange = (e) => {
    const query = e.target.value;
    setFilterValue(query);
    if (query.length >= 3 || query.length === 0) {
      setFilterValue(query);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePageForAssign = async (event, newPage) => {
    setPageAssign(newPage);
    await _getAllPatientForAdmin({
      listFilter: data?.role == "ADMIN" ? "" : "assigned-me",
      page: newPage + 1,
      limit: limitAssign,
      surveyId: formicAssign.values.surveyId,
      staffId: data._id,
    });
  };

  const handleChangeRowsPerPageForAssign = (event) => {
    setLimitAssign(parseInt(event.target.value, 10));
    setPageAssign(0);
  };

  const redirectToQuestionList = (survey) => {
    data.role == "ADMIN"
      ? navigate("/admin/survey/question-list", { state: { survey: survey } })
      : navigate("/doctor/survey/question-list", { state: { survey: survey } });
  };

  const formik = useFormik({
    ...formikCreateSurvey,
    onSubmit: async (values) => {
      values.createdBy = data._id;
      values.isActive = data.role == "ADMIN" ? values.isActive : false;
      setLoading(true);

      try {
        let res;
        if (values._id) {
          res = await updateSurvey(values);
          toast.success("Survey Updated Successfully!");
        } else {
          res = await createSurvey(values);
        }

        formik.setValues({
          title: "",
          category: "",
          description: "",
        });

        if (res.status === "SUCCESS") {
          _getSurveyList(searchText, selectedSortValue);

          toast.success(res.data.message);
          setShow(false);
        } else {
          toast.error(res.data.message);
          setShow(false);
        }

        setLoading(false);
      } catch (error) {
        toast.error("Failed!");
        setShow(false);
      }
    },
  });

  const handleEdit = (data) => {
    setShow(true);
    setEditData(data);
    formik.setValues({
      _id: data._id || "",
      title: data.title || "",
      category: data.category || "",
      description: data.description || "",
      isActive: data.isActive || false,
    });
  };

  const handleView = (data) => {
    setShowViewModel(true);
    formik.setValues({
      _id: data._id || "",
      title: data.title || "",
      category: data.category || "",
      description: data.description || "",
      isActive: data.isActive || false,
    });
  };

  const handelDeleteModel = (data) => {
    formik.setValues({
      _id: data._id,
      isDelete: true,
    });
    setDeleteModelShow(true);
  };

  const deleteSurvey = async () => {
    setLoading(false);
    await updateSurvey(formik.values);
    _getSurveyList(searchText, selectedSortValue);
    setDeleteModelShow(false);
    setLoading(true);
    toast.success("Survey Deleted Successfully!");
  };

  const handleSelect = (eventKey) => {
    setSelectedSortValue(eventKey); // Update the state with the selected value
    _getSurveyList(searchText, eventKey);
  };

  const handleSuccess = (data) => {
    _getSurveyList();
  };

  const [show, setShow] = useState(false);
  const [showViewModel, setShowViewModel] = useState(false);
  const [deleteModelShow, setDeleteModelShow] = React.useState(false);
  const [patients, setPatients] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // ****************************handle assign logic here ***************************************************************
  const [assignModelShow, setAssignModelShow] = React.useState(false); // thid is for provider
  const [assignModelAdminShow, setAssignModelAdminShow] = React.useState(false); // thid is for admin

  const [confirmInfoModelShow, setConfirmInfoModelShow] = React.useState(false);

  const [selectedAssignSortValue, setSelectedAssignSortValue] = useState("");

  const [selectedPatientIds, setSelectedPatientIds] = useState([]);

  const [filterValue, setFilterValue] = useState("");
  const fetchPatientByProviderId = async (survey) => {

    formicAssign.setFieldValue("surveyId", survey._id);
    formicAssign.setFieldValue("surveyName", survey.title);

    try {
      const result = await getPatientByProviderId({
        listFilter: data?.role == "ADMIN" ? "" : "assigned-me",
        page: pageAssign,
        limit: limitAssign,
        surveyId: survey._id,
        staffId: data._id,
      });
      setPatients(result.data.list);
      setTotalPagesAssign(result?.data?.totalPages || 0);
      setTotalItemsAssign(result?.data?.totalItems || 0);
    } catch (error) {

    }
  };
  // Initialize formik for form submission
  const formicAssign = useFormik({
    initialValues: {
      surveyId: "",
      patientId: [], // Initially empty, will update based on checkbox selection
      assignedBy: data._id, // Example static assignedBy value
      surveyName: "", // Example static survey name
      assignedToAll: false,
    },
    onSubmit: async (values) => {
      // Handle submit, send the selected patients with patientId array

      if (values?.patientId?.length < 1) {
        toast.info("Please select a patient ");
        return;
      }
      try {
        setAssignModelShow(false);
        setAssignModelAdminShow(false);
        setLoading(true);
        const result = await assignSurvey(values);

        setLoading(false);
        formicAssign.setFieldValue("patientId", []);
        setSelectedPatientIds([]);
      } catch (error) {
        setSelectedPatientIds([]);
        setLoading(false);

        formicAssign.setFieldValue("patientId", []);

        setAssignModelShow(false);
        setAssignModelAdminShow(false);
      }
    },
  });

  // Handle checkbox change
  const handleCheckboxChange = (patientId, isChecked) => {

    // Create a new array based on whether the checkbox is checked or unchecked
    let updatedPatientIds;

    if (isChecked) {
      // Add patientId to the array if it's checked
      updatedPatientIds = [...selectedPatientIds, patientId];
    } else {
      // Remove patientId from the array if it's unchecked
      updatedPatientIds = selectedPatientIds.filter((id) => id !== patientId);
    }

    // Update the state and formik at the same time
    setSelectedPatientIds(updatedPatientIds);
    formicAssign.setFieldValue("patientId", updatedPatientIds);
  };

  const handleSelectAssignSort = (eventKey) => {
    setSelectedAssignSortValue(eventKey); // Update the state with the selected value
  };

  // Handle sorting based on selectedSortValue
  const sortData = (data, sortValue) => {
    switch (sortValue) {
      case "name-asc":
        return data.sort((a, b) => a.firstName.localeCompare(b.firstName));
      case "name-dsc":
        return data.sort((a, b) => b.firstName.localeCompare(a.firstName));
      default:
        return data; // No sorting applied if "Default"
    }
  };

  // Filter and then sort the data
  const filterPatientData = useMemo(() => {
    const filteredData = filterData(patients, filterValue); // Filter patients
    return sortData(filteredData, selectedAssignSortValue); // Sort filtered data
  }, [patients, filterValue, selectedAssignSortValue]);

  const openWarningMessageModel = async (survey) => {
    setConfirmInfoModelShow(true);
    formicAssign.setFieldValue("surveyId", survey._id);
    formicAssign.setFieldValue("surveyName", survey.title);
  };

  const openAdminAssignModel = async (survey) => {
    formicAssign.setFieldValue("surveyId", survey._id);
    formicAssign.setFieldValue("surveyName", survey.title);
    setPageAssign(0);
    setTotalPagesAssign(0);
    setTotalItemsAssign(0);

    setAssignModelAdminShow(true);

    await _getAllPatientForAdmin(
      //   {
      //   page: 1, limit: 10
      // }

      {
        listFilter: data?.role == "ADMIN" ? "" : "assigned-me",
        page: 1,
        limit: 10,
        surveyId: survey._id,
        staffId: data._id,
      }
    );
    //set pagination value 0
  };

  const _getAllPatientForAdmin = async (params) => {
    try {
      const result = await getAllPatientForAdmin(params);
      setPatients(result.data.list);
      setTotalPagesAssign(result?.data?.totalPages || 0);
      setTotalItemsAssign(result?.data?.totalItems || 0);
      // setPageAssign(result?.data?.currentPage)
    } catch (error) {

    }
  };

  return (
    <div className="Dashboard-wrapper">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="add-doctor">
            <Form>
              <Form.Group controlId="searchInput">
                <Form.Control
                  type="search"
                  aria-label="Search"
                  value={searchText}
                  onChange={handleSearchChange}
                  placeholder="Search survey by title..."
                />
              </Form.Group>
            </Form>
            <div
              className="add_ques_btns d-flex align-items-center gap-2 justify-content-center"
              onClick={() => {
                handleShow();
                formik.setValues({
                  title: "",
                  category: "",
                  description: "",
                  isActive: true,
                  _id: null,
                });
              }}
            >
              <Button className="filled-btn">
                <img className="filled-btn" src={plusIcon} />
              </Button>
              <p className="mb-0">Add Survey</p>
            </div>
            {/* Button to trigger modal */}

            <Dropdown
              className="patient-info-dropdown "
              onSelect={handleSelect}
            >
              <Dropdown.Toggle className="db-dropdown h-100 ">
                {selectedSortValue === ""
                  ? "Sort By"
                  : selectedSortValue === "name-asc"
                    ? "Name A-Z"
                    : "Name Z-A"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="">Default</Dropdown.Item>
                <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
                <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="table-responsive dashboard-table">
            <table className="patients-table">
              <thead>
                <tr className="t-row-block">
                  <th scope="col">Sr No</th>
                  <th scope="col">Title</th>
                  <th scope="col">Category</th>
                  <th scope="col">Total Questions</th>
                  <th scope="col">Created By</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                  <th scope="col">Assign</th>
                </tr>
              </thead>
              <tbody>
                {surveyList.length > 0 ? (
                  surveyList.map((survey, index) => (
                    <tr key={survey.id || index}>
                      <td scope="row">{++index}</td>
                      <td onClick={() => redirectToQuestionList(survey)}>
                        <div
                          className="d-flex align-items-center gap-2 text-capitalize "
                          style={{ cursor: "pointer" }}
                        >
                          {survey?.title ? survey?.title : "-"}{" "}
                        </div>
                      </td>

                      <td>{survey?.category ? survey?.category : "-"}</td>

                      <td>
                        {survey?.questionCount ? survey?.questionCount : "0"}
                      </td>
                      <td className="text-capitalize">
                        {survey?.createdByName ? survey?.createdByName : "-"}
                      </td>
                      <td>
                        <span
                          className={`survey-status ${survey?.isActive
                              ? "survey-active-btn"
                              : "survey-inactive-btn"
                            }`}
                        >
                          {survey?.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex gap-2">
                          <a
                            className="edit-del-icon eye-edit-del eye-img"
                            onClick={() => {
                              handleView(survey);
                            }}
                          >
                            <img src={eyeimg} alt="view" />
                          </a>
                          <a
                            className="edit-del-icon eye-edit-del edit-img"
                            onClick={() => {
                              handleEdit(survey);
                            }}
                          >
                            <img src={editicon} alt="edit" />
                          </a>
                          <a
                            className="edit-del-icon eye-edit-del del-img"
                            onClick={() => handelDeleteModel(survey)}
                          >
                            <img src={binicon} alt="delete" />
                          </a>
                        </div>
                      </td>
                      <td>
                        <div className="community-info-signs d-flex align-items-center survey">
                          <Dropdown className="ms-1">
                            <Dropdown.Toggle
                              as="div"
                              id="dropdown-custom-components"
                              className="three-dots"
                            >
                              <BsThreeDotsVertical size={24} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              {survey.isActive ? (
                                <>
                                  <Dropdown.Item
                                    onClick={() =>
                                      openWarningMessageModel(survey)
                                    }
                                  >
                                    Assign to All Patient
                                  </Dropdown.Item>
                                  {data.role == "ADMIN" ? (
                                    <Dropdown.Item
                                      onClick={() => {
                                        openAdminAssignModel(survey);
                                      }}
                                    >
                                      Assign to Selected Patient
                                    </Dropdown.Item>
                                  ) : (
                                    <Dropdown.Item
                                      onClick={() => {
                                        setPageAssign(0);

                                        setAssignModelShow(true); // Open the modal
                                        fetchPatientByProviderId(survey); // Fetch the patients
                                      }}
                                    >
                                      Assign to Selected Patient
                                    </Dropdown.Item>
                                  )}
                                </>
                              ) : (
                                <Dropdown.Item>
                                  No actions for in-active survey
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No survey Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Modal to edit and add  */}
      <Modal
        className="survey-model"
        show={show}
        onHide={handleClose}
        centered
        style={{ borderRadius: "20px" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>
            {" "}
            {formik.values._id ? "Edit Survey" : "Create Survey"}{" "}
          </Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={handleClose}
          >
            {/* <i className="your-custom-icon-class">X</i> Use your icon */}
          </button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="" onSubmit={formik.handleSubmit}>
            <div className="form-control-area ">
              <Form.Group
                className="mb-3 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Survey Title <span className="asterisk">*</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      placeholder="Enter Survey Title"
                      name="title"
                      keyField={"title"}
                      formik={formik}
                      value={formik.values.title}
                      onChange={(e) =>
                        formik.setFieldValue("title", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.title && !!formik.errors.title}
                    />

                    {formik.touched.title && formik.errors.title ? (
                      <div className="text-danger">{formik.errors.title}</div>
                    ) : null}
                  </div>
                </div>
              </Form.Group>

              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Category<span className="asterisk">*</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      placeholder="Enter Category Name"
                      name="category"
                      keyField={"category"}
                      formik={formik}
                      value={formik.values.category}
                      onChange={(e) =>
                        formik.setFieldValue("category", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.category && !!formik.errors.category
                      }
                    />

                    {formik.touched.category && formik.errors.category ? (
                      <div className="text-danger">
                        {formik.errors.category}
                      </div>
                    ) : null}
                  </div>
                </div>
              </Form.Group>

              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Description<span className="asterisk">*</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={3}
                      placeholder="Enter Short Description"
                      name="description"
                      keyField={"description"}
                      formik={formik}
                      value={formik.values.description}
                      onChange={(e) =>
                        formik.setFieldValue("description", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.description &&
                        !!formik.errors.description
                      }
                    />

                    {formik.touched.description && formik.errors.description ? (
                      <div className="text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </div>
                </div>
              </Form.Group>
              {data.role == "ADMIN" && (
                <div className="col-3">
                  <Form.Check
                    className="add_ques-checkbox d-flex align-items-center gap-3"
                    label="Is Active"
                    name="isActive"
                    checked={formik.values.isActive}
                    onChange={(e) =>
                      formik.setFieldValue("isActive", e.target.checked)
                    }
                  />
                </div>
              )}
            </div>

            <div className=" = d-flex  gap-4 justify-content-end">
              <Button
                className="btn outlined-btn border-btn btn-no"
                onClick={() => setShow(false)}
              >
                Cancel
              </Button>
              {formik.values._id ? (
                <Button className="btn btn-primary filled-btn" type="submit">
                  Update
                </Button>
              ) : (
                <Button className="btn btn-primary filled-btn" type="submit">
                  Create
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal to view survey   */}
      <Modal
        className="survey-model"
        show={showViewModel}
        onHide={handleClose}
        centered
        style={{ borderRadius: "20px" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>View Survey </Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={handleClose}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="" onSubmit={formik.handleSubmit}>
            <div className="form-control-area ">
              <Form.Group
                className="mb-3 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Survey Title <span className="asterisk">*</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      placeholder="Enter Survey Title"
                      name="title"
                      keyField={"title"}
                      formik={formik}
                      value={formik.values.title}
                      readOnly
                    />
                  </div>
                </div>
              </Form.Group>

              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Category<span className="asterisk">*</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      placeholder="Enter Category Name"
                      name="category"
                      keyField={"category"}
                      formik={formik}
                      value={formik.values.category}
                    />
                  </div>
                </div>
              </Form.Group>

              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Description<span className="asterisk">*</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={3}
                      placeholder="Enter Short Description"
                      name="description"
                      keyField={"description"}
                      formik={formik}
                      value={formik.values.description}
                    />
                  </div>
                </div>
              </Form.Group>

              <div className="col-3">
                <span
                  className={`survey-status ${formik.values.isActive
                      ? "survey-active-btn"
                      : "survey-inactive-btn"
                    }`}
                >
                  {formik.values.isActive ? "Active" : "Inactive"}
                </span>
              </div>
            </div>

            <div className=" = d-flex  gap-4 justify-content-end">
              <Button
                className="btn outlined-btn border-btn btn-no"
                onClick={() => setShowViewModel(false)}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* delete survey modal */}
      <Modal
        className="dlt-patient-modal"
        show={deleteModelShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDeleteModelShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="delete-img">
              <img src={reddelete} alt="img"></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to detele this survey</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              className="btn border-btn btn-no outlined-btn"
              onClick={() => setDeleteModelShow(false)}
            >
              No
            </Button>
            <Button
              className="btn dark-btn btn-yes"
              onClick={() => deleteSurvey()}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal to assign survey to patient for provider */}
      <Modal
        className="survey-model-assign"
        show={assignModelShow}
        onHide={() => setAssignModelShow(false)}
        centered
        size="lg"
        style={{ borderRadius: "20px", width: "100%" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>{"Assign Survey"}</Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={() => setAssignModelShow(false)}
          >
            {/* Close icon here */}
          </button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="add-doctor">
            <Form>
              <Form.Group controlId="searchInput">
                <Form.Control
                  type="search"
                  aria-label="Search"
                  value={filterValue}
                  onChange={handleSearchAssignPatientChange}
                  placeholder="Search patient by name..."
                />
              </Form.Group>
            </Form>
            {/* Button to trigger modal */}

            <Dropdown
              className="patient-info-dropdown "
              onSelect={handleSelectAssignSort}
            >
              <Dropdown.Toggle className="db-dropdown h-100 ">
                {selectedSortValue === ""
                  ? "Sort By"
                  : selectedSortValue === "name-asc"
                    ? "Name A-Z"
                    : "Name Z-A"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="">Default</Dropdown.Item>
                <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
                <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
                {/* <Dropdown.Item eventKey="low-icbps">Low ICBPS</Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <Form onSubmit={formicAssign.handleSubmit}>
            <div className="table-responsive dashboard-table">
              <table className="patients-table">
                <thead>
                  <tr className="t-row-block" style={{ color: "white" }}>
                    <th scope="col">
                      {/* <Form.Check
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => handleCheckboxChange(null, e.target.checked)}
                  /> */}
                      Select{" "}
                    </th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {filterPatientData?.length > 0 ? (
                    filterPatientData?.map((patient, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            onChange={(e) =>
                              handleCheckboxChange(
                                patient?._id,
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          {patient?.firstName || "-"} {patient?.lastName}{" "}
                        </td>
                        <td>{patient?.email || "-"}</td>
                        <td>{patient?.phone || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Patients Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="pagination-blk mb-4">
              <CustomPagination
                totalItems={totalItemsAssign}
                page={pageAssign}
                onPageChange={handleChangePageForAssign}
                limit={limitAssign}
                onRowsPerPageChange={handleChangeRowsPerPageForAssign}
              />
            </div>
            <div className="d-flex gap-4 justify-content-end">
              <Button
                className="btn outlined-btn border-btn btn-no"
                onClick={() => setAssignModelShow(false)}
              >
                Cancel
              </Button>
              <Button className="btn dark-btn btn-yes" type="submit">
                Assign Survey
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal to assign survey to patient for admin */}
      <Modal
        className="survey-model-assign"
        show={assignModelAdminShow}
        onHide={() => setAssignModelAdminShow(false)}
        centered
        size="lg"
        style={{ borderRadius: "20px", width: "100%" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>{"Admin Assign Survey"}</Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={() => setAssignModelAdminShow(false)}
          >
            {/* Close icon here */}
          </button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form onSubmit={formicAssign.handleSubmit}>
            <div className="table-responsive dashboard-table">
              <table className="patients-table">
                <thead>
                  <tr className="t-row-block" style={{ color: "white" }}>
                    <th scope="col">
                      {/* <Form.Check
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => handleCheckboxChange(null, e.target.checked)}
                  /> */}
                      Select{" "}
                    </th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {patients?.length > 0 ? (
                    patients?.map((patient, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            onChange={(e) =>
                              handleCheckboxChange(
                                patient?._id,
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          {patient?.firstName || "-"} {patient?.lastName}{" "}
                        </td>
                        <td>{patient?.email || "-"}</td>
                        <td>{patient?.phone || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Patients Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="pagination-blk text-center mb-4">
              <CustomPagination
                totalItems={totalItemsAssign}
                page={pageAssign}
                onPageChange={handleChangePageForAssign}
                limit={limitAssign}
                onRowsPerPageChange={handleChangeRowsPerPageForAssign}
              />
            </div>
            <div className="d-flex gap-4 justify-content-end">
              <Button
                className="btn outlined-btn border-btn btn-no"
                onClick={() => setAssignModelAdminShow(false)}
              >
                Cancel
              </Button>
              <Button className="btn dark-btn btn-yes" type="submit">
                Assign Survey
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* delete survey modal */}
      <Modal
        className="dlt-patient-modal"
        show={confirmInfoModelShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmInfoModelShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="" style={{ height: "100px", width: "100px" }}>
              <img
                style={{ height: "100px", width: "100px" }}
                src={exclamation}
                alt="img"
              ></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to assign this survey to all patient</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              // className="btn border-btn btn-no"
              className="btn btn-primary outlined-btn"
              onClick={() => setConfirmInfoModelShow(false)}
            >
              No
            </Button>
            <Button
              className="btn dark-btn btn-yes"
              onClick={async () => {
                setLoading(true);
                setConfirmInfoModelShow(false);
                await assignSurveyToAllPatient(formicAssign.values);

                setLoading(false);
              }}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default SurveyList;
